import { useState } from 'react';

/*
  Allows a mobile user to swipe through a carousel or something similar
*/

type UseSwipeParams = {
  numberOfElements: number;
};

type UseSwipeResponse = {
  handleTouchStart: (e: React.TouchEvent<HTMLDivElement>) => void;
  handleTouchMove: (e: React.TouchEvent<HTMLDivElement>) => void;
  index: number;
  setIndex: (newIndex: number) => void;
};

export const useSwipe = ({
  numberOfElements,
}: UseSwipeParams): UseSwipeResponse => {
  const [index, setIndex] = useState(0);
  const [touchPosition, setTouchPosition] = useState<null | number>(null);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    const touchDown = touchPosition;
    if (touchDown === null) return;

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5 && index !== numberOfElements) {
      setIndex(index + 1);
    } else if (diff < -5 && index !== 0) {
      setIndex(index - 1);
    }

    setTouchPosition(null);
  };

  return { handleTouchStart, handleTouchMove, index, setIndex };
};
